import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {localization} from '../Frames/localization'
import {ColorLinearProgress} from '../../src/App'
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

import MessageWindow from '../Elements/Snackbar/MessageWindow'
import {messageWindow} from '../Elements/Snackbar/MessageWindow'

import {ThemeCheckbox} from '../../src/App'
import { ThemeProvider } from "@material-ui/styles";

import Label from '../Elements/Label/labels'

//settings
import {AppliedSettings} from '../../src/App' 

import {CashbackBox,TableCurrentRules,TableExpectedRules} from './ElementsPage/BoxsCashBack'

import './cashback.css'
import './cashbackAdaptive.css'

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
class Cashback extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            TabNotAvailable: false,
            asyncDisabled: false,
            progress: false,

            key: undefined,
            isLoaded: false,
            res: Array, 

            ExpectedCount: 0
        }

        this.selectvalue = this.selectvalue.bind(this)
        this.variant = this.variant.bind(this)
        this.ShowMessage = this.ShowMessage.bind(this)
    }
    ShowMessage(type,data)
    {
        messageWindow.OpenMessage(type, data)
        this.setState({key: Math.random()})
    }
    componentDidMount() {
        this.props.setSelectedIndex(2)
        fetch(`/api/getCashback`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
                if(response.data == null){
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({key: Math.random(),open: true})
                }
                else
                {
                    this.setState({
                        res: response,
                        isLoaded: true,
                    })
                }     
        }).catch((error) => {
            // Handle the error
            this.setState({TabNotAvailable: true})
          })
        this.forceUpdate();
      }
      /*onSubmit(event){
        this.setState({asyncDisabled: true, progress: true})
        var id_product = [];
        var id_rule = [];

        var form = document.getElementById('cashForm');
        var checkboxes = form.getElementsByTagName("input")
        for(var j=0; j<checkboxes.length; j++)
        {
            if (checkboxes[j].type == 'checkbox')
            {
                if (checkboxes[j].checked == true)
                {   
                    id_product.push(checkboxes[j].id)
                }
            }
        }

        var Rules = this.state.res.data.BonAchCashR;  
        for(var i=0; i<Rules.length; i++)
            {
                var blockRule = document.getElementById("List-"+Rules[i].id);
                var checkboxesRule = blockRule.getElementsByTagName("input")
                for(var j=0; j<checkboxesRule.length; j++)
                {
                    if (checkboxesRule[j].type == 'checkbox')
                    {
                        if (checkboxesRule[j].checked == true)
                        {   
                            id_rule.push(Rules[i].id);
                        }
                    }
                }
            }
        var data = {
            id_Rule: id_rule,
            id_Product: id_product
        }
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/alterCashback`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({asyncDisabled: false, progress: false,key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.error == null)
            {
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({asyncDisabled: false, progress: false,key: Math.random()})
            }else
            {
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({asyncDisabled: false, progress: false,key: Math.random()})
            }
        })
        this.forceUpdate()
        event.preventDefault();
      }*/
    selectvalue(str)
      {
          var cash;
          cash = str.substring(str.search(',')+1,str.search('}')); 
          return cash;
      }
    variant(str)
    {
        var cash;
        cash = str.substring(str.search('{')+1,str.search(',')); 
        return cash;
    }
    render() {
        /*const { res, isLoaded, progress } = this.state;
        return(
            <div>
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            }  
            <div className="containers"> 
            <MessageWindow key={this.state.key} ></MessageWindow> 
            {!isLoaded &&  
                <div class="preloader"></div>
            } 
            {isLoaded &&
                <div>  
                    {res.data.Cash_Y_N === true &&
                    <div>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <CashbackBox res={res}></CashbackBox>
                        </Grid>
                    </Grid> 
                    <form name="Form" id="cashForm" onSubmit={this.onSubmit}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={ThemeCheckbox}>
                            {res.data.BonAchR_empty === false &&
                            <div>
                                {res.data.BonAchCashR.map(item => (
                                    <div>
                                        {this.variant(item.comment) == 1 &&
                                            <div>
                                                <SelectCaskBack_SkuSet 
                                                id={item.id}
                                                name={item.name}
                                                beginDate={item.beginDate}
                                                endDate={item.endDate}
                                                position={this.selectvalue(item.comment)}
                                                />
                                            </div>  
                                        }
                                        {this.variant(item.comment) == 2&&
                                            <div>
                                                <SelectCaskBack_ExtSku 
                                                id={item.id}
                                                name={item.name}
                                                beginDate={item.beginDate}
                                                endDate={item.endDate}
                                                position={this.selectvalue(item.comment)}
                                                />
                                            </div>
                                        }
                                    </div>
                                      ))                             
                                }
                            </div>
                            }
                            </ThemeProvider>                           
                        </Grid>
                    </Grid>
                    <div className="BoxSaveButton">
                        <Button
                                variant="contained"
                                type="submit"
                                value="submit"
                                color="primary"
                                textLabel={localization.GetTranslate('buttons.Save')}
                                className="SaveButton"
                                disabled={this.state.asyncDisabled}
                            >
                        </Button> 
                        
                    </div> 
                    </form> 
                    </div>
                    }
                    {res.data.Cash_Y_N === false &&
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <br></br>
                                <Label textLabel={localization.GetTranslate('Cashback.Cashback is not available')} className="CashbackLabelNotAvailable"></Label>
                        </Grid>
                    </Grid> 
                    }
                    
                </div>
            }
            </div>
            </div>
        );
        */
       const { res, isLoaded, progress, TabNotAvailable } = this.state;
       var {ExpectedCount} = this.state;
       if(res.data != undefined)
       {
            res.data.BonAchCashR.map(item =>{
                if(item.beginDate > Date.now())
                {
                    ExpectedCount ++;
                }
            })
       }
       if(AppliedSettings.cashback_hide_rule_panel === 1)
       {
        ExpectedCount = 1;
       }
       if(AppliedSettings.cashback_hide_rule_panel === 2)
       {
        ExpectedCount = 0;
       }
       return(
            <div>
            {TabNotAvailable == true &&
            <div className="containers">
                <div className="TabNotAvailable">
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={localization.GetTranslate('Alert.TabNotAvailable')} className="CashbackLabelNotAvailable"></Label>   
                    </Grid>
                </Grid>
                </div>                
            </div>
            }
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            }  
            <div className="containers"> 
            <MessageWindow key={this.state.key} ></MessageWindow> 
            {!isLoaded &&  
                TabNotAvailable == false &&
                <div class="preloader"></div>
            } 
            {isLoaded &&
                <div>  
                    {res.data.Cash_Y_N === true &&
                    <div>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <CashbackBox res={res}></CashbackBox>
                        </Grid>
                    </Grid> 
                    {/*<form name="Form" id="cashForm" onSubmit={this.onSubmit}>*/}
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={ThemeCheckbox}>
                                <Paper className={ExpectedCount > 0 ? "SelectCashBackCurrentRules":"SelectCashBackCurrentRules_FullWidth"}>
                                    <div style={{paddingTop: 15, paddingBottom: 15}}>
                                        <Label textLabel={localization.GetTranslate('Cashback.Current rules')} className="SelectCashBackLabel"></Label>
                                    </div>
                                    <Divider className="Divider"/>
                                    {res.data.BonAchR_empty === false &&
                                    <TableCurrentRules
                                        AppliedSettings={AppliedSettings}
                                        BonAchR_empty={res.data.BonAchR_empty}
                                        BonAchCashR={res.data.BonAchCashR}
                                        selectvalue = {this.selectvalue}
                                        variant = {this.variant}
                                        onSubsmit={this.onSubmit}
                                        ShowMessage={this.ShowMessage}
                                        type="current"
                                        UpdateCashBackInfo={this.UpdateCashBackInfo}
                                    ></TableCurrentRules>
                                    }
                                </Paper>
                            </ThemeProvider>                           
                        </Grid>
                        {ExpectedCount > 0 && 
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={ThemeCheckbox}>
                                
                                <Paper className="SelectCashBackExpectedRules">
                                    <div style={{paddingTop: 15, paddingBottom: 15}}>
                                        <Label textLabel={localization.GetTranslate('Cashback.Expected rules')} className="SelectCashBackLabel"></Label>
                                    </div>
                                    <Divider className="Divider"/>
                                    {res.data.BonAchR_empty === false &&
                                    <TableExpectedRules
                                        AppliedSettings={AppliedSettings}
                                        BonAchR_empty={res.data.BonAchR_empty}
                                        BonAchCashR={res.data.BonAchCashR}
                                        selectvalue = {this.selectvalue}
                                        variant = {this.variant}
                                        onSubsmit={this.onSubmit}
                                        ShowMessage={this.ShowMessage}
                                        type="expected"
                                        UpdateCashBackInfo={this.UpdateCashBackInfo}
                                    ></TableExpectedRules>
                                    }
                                </Paper>
                            </ThemeProvider>                           
                        </Grid>
                        }
                    </Grid>
                    {/* <div className="BoxSaveButton">
                        <Button
                                variant="contained"
                                type="submit"
                                value="submit"
                                color="primary"
                                textLabel={localization.GetTranslate('buttons.Save')}
                                className="SaveButton"
                                disabled={this.state.asyncDisabled}
                            >
                        </Button> 
                        
                                </div> 
                    </form> */}
                    </div>
                    }
                    {res.data.Cash_Y_N === false &&
                    <div className="TabNotAvailable">
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <br></br>
                                <Label textLabel={localization.GetTranslate('Cashback.Cashback is not available')} className="CashbackLabelNotAvailable"></Label>
                        </Grid>
                    </Grid>
                    </div> 
                    }
                    
                </div>
            }
            </div>
            </div>
        );
    }
}
export default Cashback;

